export default __webpack_public_path__ + "static/media/244f611dfc18b39a8b5355763e97f4b11580830362828.10a808de.webp";